// src/utils/oauth.tsx
var standardProviders = ["google", "github", "microsoft", "spotify", "facebook", "discord", "gitlab", "bitbucket", "linkedin", "apple", "x"];
var sharedProviders = ["google", "github", "microsoft", "spotify"];
var allProviders = standardProviders;
export {
  allProviders,
  sharedProviders,
  standardProviders
};
//# sourceMappingURL=oauth.js.map